import {read, unsubscribe, subscribe} from './queue.js';
import {uuid} from 'uuidv4';

const EMPTY = [];
// Allows reading from a stream of messages as they come in
// You read once which reads everything thats happened since you last
// called read.
export const reader = (type, isBad=false) => {
    let queued = read(type).slice(0, 1);
    let id = uuid();

    let fn = (x) => {
        queued = [x, ... queued];
    };

    subscribe(
        type, 
        fn,
        isBad);

    return (destroy=false) => {
        if (destroy) {
            return unsubscribe(type, fn);
        }

        if (queued.length === 0) {
            return EMPTY;
        }

        let ret = [... queued];
        queued = [];
        return ret;
    };
};
